export default {
  checkout: {
    seo: {
      cartTitle: 'Tour Cart | AQUAMARINA TOURS',
      cartDescription: 'Your cart of Paraty tours. Add schooner, speedboat and jeep tours to your list and book via WhatsApp.',
    },
    cart: {
      item: 'item',
      items: 'items',
      clear: 'Empty cart',
      tourDate: 'Tour date:',
      review: 'Review your selected tours and confirm your booking with secure payment.',
      deposit: 'Deposit via PIX',
      remaining: 'Balance due on tour day',
      depositNote: 'The deposit is {{percent}}% of the total, with a minimum of R$ 20,00.',
      full: 'Full payment via PIX',
      fullNote: 'The full amount is paid now to secure the booking.',
      continuePayment: 'Continue to payment',
      clearConfirmTitle: 'Empty your cart?',
      clearConfirmText: 'All items will be removed. This action cannot be undone.',
      cancel: 'Cancel',
      clearConfirm: 'Empty',
    },
    modal: {
      titlePix: 'Pay the deposit with Pix',
      titleDetails: 'Lead guest details',
      close: 'Close',
      adults_one: '{{count}} adult',
      adults_other: '{{count}} adults',
      children_one: '{{count}} child',
      children_other: '{{count}} children',
      babies_one: '{{count}} baby',
      babies_other: '{{count}} babies',
      participants_one: '{{count}} guest',
      participants_other: '{{count}} guests',
      depositLabel: 'Deposit via Pix ({{percent}}%)',
      remainingNote: 'The balance ({{amount}}) is paid on the day of the tour.',
      qrAlt: 'Pix QR code',
      scanHint: 'Scan the QR code in your banking app or use the Pix copy-and-paste code.',
      copied: 'Code copied!',
      copyPix: 'Copy Pix code',
      waiting: 'Waiting for payment — confirmation will appear here automatically.',
      fillIn: 'Fill in the details of the person making the booking.',
      fullName: 'Full name',
      fullNamePlaceholder: 'First and last name',
      whatsapp: 'WhatsApp',
      ticketEmailHint: 'Your ticket will arrive at this email as soon as the booking is confirmed.',
      pickupLabel: 'Where we pick you up',
      pickupPlaceholder: 'Hotel, guesthouse or address in Paraty',
      pickupAgency: 'Board at the agency',
      pickupHint: 'Free pick-up from 10:20 to 11:00 in central Paraty (up to 3 km from the agency). The guide confirms the time on WhatsApp.',
      pickupAgencyHint: 'You board at the agency: the time to be there is on your ticket.',
      email: 'Email',
      emailPlaceholder: 'you@example.com',
      cpf: 'CPF',
      requiredOnline: '(required to pay online)',
      talkWhatsApp: 'Talk to our team on WhatsApp',
      generatingPix: 'Generating Pix…',
      payPix: 'Pay {{amount}} deposit with Pix',
      sendWhatsApp: 'Send booking via WhatsApp',
      openingMp: 'Opening Mercado Pago…',
      payCard: 'I prefer to pay by card (Mercado Pago)',
      secure: 'Payments securely processed by Mercado Pago',
      errors: {
        fullName: 'Please enter your first and last name.',
        whatsapp: 'Please enter a WhatsApp number with area code.',
        email: 'Please enter a valid email.',
        cpf: 'Invalid CPF.',
        pickup: 'Tell us where to pick you up or choose to board at the agency.',
        offline: 'Online payment only works on the published site (or with "npx netlify dev"). You can send your booking via WhatsApp.',
        generic: 'The operation could not be completed.',
        pixFailed: 'Could not generate the Pix.',
        paymentFailed: 'Could not start the payment.',
      },
    },
    flow: {
      steps: { cart: 'Cart', holder: 'Lead guest', payment: 'Payment', confirm: 'Confirmation' },
      stepOf: 'Step {{current}} of {{total}}',
      titles: {
        payment: 'How would you like to pay?',
        approved: 'Payment approved',
        inProcess: 'Payment under review',
        rejected: 'Payment not approved',
      },
      summary: {
        title: 'Booking summary',
        show: 'Show summary',
        hide: 'Hide summary',
        total: 'Total',
        dueNow: 'Deposit charged now ({{percent}}%)',
        dueNowPlain: 'Deposit charged now',
        fullNow: 'Full amount charged now',
        dueNowShort: 'Deposit now',
        dueOnDay: 'Balance on the day of the tour',
        date: 'Date',
        guests: 'Guests',
        empty: 'Your bag is empty.',
      },
      document: {
        legend: 'ID document',
        cpf: 'CPF',
        passport: 'Passport',
        cpfHint: 'Numbers only; we format it for you.',
        passportNumber: 'Passport number',
        passportPlaceholder: 'e.g. AB1234567',
        passportHint: 'For international visitors.',
        nationality: 'Passport country',
        nationalityPlaceholder: 'Select a country',
        frequent: 'Most common',
        allCountries: 'All countries',
      },
      errors: {
        passport: 'Enter your passport number (5 to 20 letters or digits).',
        nationality: 'Select the passport country.',
        pixNeedsCpf: 'Mercado Pago required a CPF for this Pix. Enter a CPF or confirm your booking on WhatsApp.',
        cardSdk: 'The secure card form could not be loaded. Check your connection and try again, or pay through the Mercado Pago checkout.',
      },
      actions: {
        continue: 'Continue to payment',
        back: 'Back',
        editDetails: 'Edit',
        whatsappInstead: 'I prefer to send my booking via WhatsApp',
        retry: 'Try again',
        tryAnotherCard: 'Try another card',
        payWithPix: 'Pay with Pix',
        payWithCard: 'Pay by credit card',
        newPix: 'Generate a new Pix',
        showPix: 'Show the Pix QR code',
        viewReservation: 'View my booking',
        otherMethod: 'Another payment method',
      },
      whatsappNote: 'Name and WhatsApp are all we need for WhatsApp.',
      tabs: { label: 'Payment method', pix: 'Pix', card: 'Credit card' },
      pix: {
        instant: 'Confirmed instantly',
        validity: 'QR code valid for 30 minutes',
        anyBank: 'Works in any Brazilian banking app',
        passportNote: 'With a passport, some banks and accounts require a CPF for Pix. If it does not work, confirm your booking on WhatsApp.',
        expiresIn: 'Expires in {{time}}',
        expired: 'This Pix has expired. Generate a new code to pay.',
        paste: 'Pix copy-and-paste',
      },
      card: {
        lead: '{{amount}} deposit in up to 3 instalments. Card details go straight to Mercado Pago and never touch our site.',
        loading: 'Loading secure form…',
        processing: 'Processing payment…',
        fallbackNote: 'You will be taken to the secure Mercado Pago checkout to pay by card (up to 3 instalments) and brought back here afterwards.',
        fallbackButton: 'Pay {{amount}} by card on Mercado Pago',
      },
      result: {
        approvedDesc: 'Your deposit is paid and your booking is confirmed. Opening your confirmation…',
        inProcessDesc: 'Mercado Pago is reviewing the payment. You will get the answer by email, usually within minutes.',
        rejectedDesc: 'Nothing was charged. You can try another card or pay with Pix.',
        paymentId: 'Payment #{{id}}',
      },
      statusDetail: {
        accredited: 'Payment approved.',
        pending_contingency: 'We are processing the payment. You will receive the result by email within 2 business days.',
        pending_review_manual: 'The payment is being reviewed. You will receive the result by email within 2 business days.',
        cc_rejected_bad_filled_card_number: 'Check the card number.',
        cc_rejected_bad_filled_date: 'Check the card expiry date.',
        cc_rejected_bad_filled_other: 'Check the card details.',
        cc_rejected_bad_filled_security_code: 'Check the card security code (CVV).',
        cc_rejected_blacklist: 'This card could not be used. Please use another card or Pix.',
        cc_rejected_call_for_authorize: 'Your bank needs to authorise this payment. Call your bank and try again.',
        cc_rejected_card_disabled: 'This card is not active. Call your bank to activate it or use another card.',
        cc_rejected_card_error: 'The payment could not be processed. Try again or use another card.',
        cc_rejected_duplicated_payment: 'You already made a payment for this amount. To pay again, use another card or Pix.',
        cc_rejected_high_risk: 'The payment was declined for security reasons. Use another card or pay with Pix.',
        cc_rejected_insufficient_amount: 'The card does not have enough credit. Use another card or Pix.',
        cc_rejected_invalid_installments: 'This card does not accept that number of instalments. Pay in full or use another card.',
        cc_rejected_max_attempts: 'You reached the attempt limit. Use another card or Pix.',
        cc_rejected_other_reason: 'Your bank did not approve the payment. Use another card or Pix.',
        default: 'The payment was not approved. Use another card or pay with Pix.',
      },
    },
    paymentReturn: {
      loadingTitle: 'Verifying your payment…',
      approvedTitle: 'Payment approved',
      pendingTitle: 'Payment pending',
      failedTitle: 'Payment not completed',
      loadingDesc: 'We are confirming the result with Mercado Pago.',
      approvedDesc: 'Your booking is confirmed. Send the confirmation via WhatsApp so our team can hold your spots.',
      pendingDesc: 'Mercado Pago is still processing the payment. As soon as it is approved, your booking will be confirmed.',
      failedDesc: 'No charge was confirmed. You can try again or talk to our team on WhatsApp.',
      emailSent: 'We sent your PDF ticket to the email you provided.',
      emailFailed: 'Your booking is confirmed, but we could not send the email. You can open your ticket below.',
      sendConfirmation: 'Send confirmation via WhatsApp',
      talkTeam: 'Talk to our team on WhatsApp',
      viewTicket: 'View my ticket',
      backToCart: 'Back to cart',
      confirmedTitle: 'Booking confirmed!',
      thanks: 'Thank you, {{name}}! Your spot on {{tour}} is secured. See you on board.',
      ticketByEmail: 'Your ticket arrives at {{email}}, and you can also download it as a PDF.',
      summaryDate: 'Date',
      summaryPeople: 'Guests',
      summaryPaid: 'Deposit paid',
      summaryRemaining: 'Balance on the day',
      ticketHeadline: 'BOOKING CONFIRMED',
      ticketDate: 'Date',
      ticketPeople: 'Guests',
      ticketCode: 'Code',
      ticketPaid: 'PIX ✓ PAID',
    },
    ticket: {
      notFound: 'Ticket not found',
      backToSite: 'Back to the site',
      title: 'Booking ticket',
      holder: 'LEAD GUEST',
      whatsapp: 'WhatsApp: {{phone}}',
      confirmed: 'CONFIRMED',
      participants_one: '{{count}} guest',
      participants_other: '{{count}} guests',
      total: 'Total',
      depositPaid: 'Deposit paid',
      downloadPdf: 'Download PDF',
      addWallet: 'Add to Wallet',
      walletAlert: 'Wallet requires setting up Apple Wallet or Google Wallet as an issuer.',
    },
  },
};
